module.exports = __webpack_public_path__ + "50c9df4833cd83c73f554b6db36b2ec9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/fannypack-s.png
// module id = 1836
// module chunks = 0